import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React, { Fragment, useCallback } from 'react';
import { Text, OutlineButton } from 'roo-ui/components';
import { getQffAuth } from 'lib/qffAuth';
import { useDataLayer } from 'hooks/useDataLayer';
import { LogOutButton } from 'components/QffMenu/primitives';
import QffPersonalInfo from 'components/QffMenu/QffPersonalInfo';
import QffLinks from 'components/QffMenu/QffLinks';

const logout = async () => {
  try {
    const qffAuth = await getQffAuth();
    qffAuth.logout();
  } catch (e) {
    //do nothing yet
  }
};

const QffMenuContent = ({ onLogout }) => {
  const { emitInteractionEvent } = useDataLayer();

  const handleLogoutClick = useCallback(() => {
    emitInteractionEvent({ type: 'QFF Login Dropdown', value: 'Log Out Selected' });
    logout();
    onLogout();
  }, [emitInteractionEvent, onLogout]);

  return (
    <Fragment>
      <Text fontSize="base" pl={5} py={5}>
        Frequent Flyer Login
      </Text>
      <QffPersonalInfo />
      <QffLinks />
      <LogOutButton>
        <OutlineButton onClick={handleLogoutClick} variant="primary" mx={5} width="100%" data-testid="logout-button">
          LOG OUT
        </OutlineButton>
      </LogOutButton>
    </Fragment>
  );
};

QffMenuContent.propTypes = {
  onLogout: PropTypes.func,
};

QffMenuContent.defaultProps = {
  onLogout: noop,
};

export default QffMenuContent;
